// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"da5df132","257":"93daa266","452":"66db4d2b","453":"0c755fb4","806":"df189340","883":"a8663369"}[chunkId] + ".chunk.js";
};